export default "__VITE_ASSET__URwUvf32__"